export default "__VITE_ASSET__yKzF2WWS__"